import { render, staticRenderFns } from "./TopCard.vue?vue&type=template&id=0c40c8cc&scoped=true&"
import script from "./TopCard.vue?vue&type=script&lang=js&"
export * from "./TopCard.vue?vue&type=script&lang=js&"
import style0 from "./TopCard.vue?vue&type=style&index=0&id=0c40c8cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c40c8cc",
  null
  
)

export default component.exports